import React from "react";
import HeaderServices from "./HeaderServices/index";
import OurServices from "./OurServices/index";
import Testi from "./Testi/index";
import Subscribe from "../About/Subscribe/index";

function ServicesSec() {
    return (
        <>
            <HeaderServices />
            <OurServices />
            <Testi />
            <Subscribe />
        </>
    )
}

export default ServicesSec;